export default __webpack_public_path__ + "static/media/search.ab72a71d.svg";